export default __webpack_public_path__ + "static/media/25501.fe6cd0d8.jpg";